import { apiFetch } from "../../utils/apiFetch";

// Read at call time, not import time, so tests can set the env var per test.
const base = () => process.env.REACT_APP_PAYVIEW_BASE_URL;

const failWith = async (res, fallback) => {
  const data = await res.json();
  throw new Error(data.error || fallback);
};

// `apiPath` is the owning record's API path — `/api/deals/7` or
// `/api/marketing/sessions/3` — both of which serve the same message and
// document sub-routes.
export const fetchMessageBody = async (apiPath, messageId) => {
  const res = await apiFetch(
    `${base()}${apiPath}/messages/${messageId}/body/`
  );
  if (!res.ok) await failWith(res, "Failed to load email body");
  return res.json();
};

// Fetch (not a plain link) because the download endpoint needs the JWT header;
// it answers with a short-lived presigned URL that the browser then opens.
export const openDocument = async (apiPath, documentId) => {
  const res = await apiFetch(
    `${base()}${apiPath}/documents/${documentId}/download/`
  );
  if (!res.ok) await failWith(res, "Failed to get download link");
  const { url } = await res.json();
  window.open(url, "_blank", "noopener");
};

const adminDealAction = async (dealId, path, method, fallback) => {
  const res = await apiFetch(`${base()}/api/admin/deals/${dealId}/${path}`, {
    method,
  });
  if (!res.ok) await failWith(res, fallback);
};

export const cancelAdminDeal = (dealId) =>
  adminDealAction(dealId, "cancel/", "POST", "Failed to cancel deal");

export const resetAdminDeal = (dealId) =>
  adminDealAction(dealId, "reset-status/", "POST", "Failed to reset deal status");

export const deleteAdminDeal = (dealId) =>
  adminDealAction(dealId, "", "DELETE", "Failed to delete deal");
